@import 'src/styles/variabels';

.wrap {
  flex-grow: 1;
  display: grid;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 2rem 0;
}

.data {
  display: grid;
  grid-template-columns: repeat(2, auto);
  align-items: center;
  color: $color-secondary;
  font-size: 5rem;
  grid-gap: 1rem;
}

.text {
  text-transform: uppercase;
}

@media (max-width: map-get($breakpoints, 'lg') - 1 + px) {
  .data {
    grid-template-columns: 1fr;
  }
  .icon {
    margin: 0 auto;
  }
}
